<template>
    <div
        class="RiskProfilesExpandableRows"
        :class="{'RiskProfilesExpandableRows--expanded': expanded}"
    >
        <div class="RiskProfilesExpandableRows__summaryRowContainer">
            <div class="RiskProfilesExpandableRows__summaryRow">
                <div class="RiskProfilesExpandableRows__summaryBranch">
                    <div class="RiskProfilesExpandableRows__expandableCaret" @click="toggle">
                        <FontAwesomeIcon v-if="expanded" :icon="faAngleDown" />
                        <FontAwesomeIcon v-else :icon="faAngleUp" />
                    </div>
                    <div class="RiskProfilesExpandableRows__summaryBranchLower" />
                </div>
                <div class="RiskProfilesExpandableRows__cells">
                    <div class="RiskProfilesExpandableRows__summaryNameCell">
                        <span @click="toggle">
                            Effective Profile:
                        </span>
                    </div>
                    <div class="RiskProfilesExpandableRows__summaryRequirementTypesContentCell">
                        {{ summaryRequirementTypes }}
                    </div>
                    <div class="RiskProfilesExpandableRows__summaryComplianceStatusContentCell">
                        <ComplianceStatusBadge :status="entity.complianceStatus" />
                    </div>
                </div>
            </div>
        </div>
        <template v-if="expanded">
            <div
                v-for="profile in entityRiskProfiles"
                :key="profile.id"
                class="RiskProfilesExpandableRows__rowContainer"
            >
                <div class="RiskProfilesExpandableRows__row">
                    <div class="RiskProfilesExpandableRows__branch">
                        <div class="RiskProfilesExpandableRows__branchUpper" />
                        <div class="RiskProfilesExpandableRows__branchLower" />
                    </div>
                    <div class="RiskProfilesExpandableRows__cells">
                        <div class="RiskProfilesExpandableRows__displayNameContentCell">
                            <span @click="$emit('goToRiskProfile', profile.id)">
                                {{ profile.displayName }}
                            </span>
                        </div>
                        <div class="RiskProfilesExpandableRows__requirementTypesContentCell">
                            {{ profile.coverageTypes.length }}
                        </div>
                        <div class="RiskProfilesExpandableRows__complianceStatusContentCell">
                            <ComplianceStatusBadge :status="profile.complianceStatus" />
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from '@evidentid/vue-property-decorator';

    import union from 'lodash/union';

    import { faAngleDown, faAngleUp } from '@fortawesome/pro-light-svg-icons';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    import { Entity } from '@evidentid/tprm-portal-lib/models/dashboard';
    import { EntityRiskProfile } from '@evidentid/tprm-portal-lib/models/decisioning';
    import { TprmRequirementType } from '@evidentid/tprm-portal-lib/models/entity-details';

    import ComplianceStatusBadge from '@/modules/dashboard/components/ComplianceStatusBadge/ComplianceStatusBadge.vue';

    @Component({
        emits: [ 'goToRiskProfile' ],
        components: { ComplianceStatusBadge, FontAwesomeIcon },
    })
    export default class RiskProfilesExpandableRows extends Vue {
        @Prop({ type: Array, default: () => [] })
        private entityRiskProfiles!: EntityRiskProfile[];

        @Prop({ type: Object, required: true })
        private entity!: Entity;

        private faAngleDown = faAngleDown;
        private faAngleUp = faAngleUp;
        private expanded = true;

        private get summaryRequirementTypes(): number {
            return this.entityRiskProfiles
                .reduce((accu, profile) => union(accu, profile.coverageTypes), [] as TprmRequirementType[])
                .length;
        }

        private toggle(): void {
            this.expanded = !this.expanded;
        }
    }
</script>
